export const EVENTS = {
  FORM_SUBMISSION_SUCCESS: 'formSubmissionSuccess',
  PAGE_LOAD: 'pageLoad',
  GENERIC_EVENT: 'genericEvent',
};
